import { render, staticRenderFns } from "./v-supply-select-list.vue?vue&type=template&id=2d32b348&scoped=true&"
import script from "./v-supply-select-list.vue?vue&type=script&lang=js&"
export * from "./v-supply-select-list.vue?vue&type=script&lang=js&"
import style0 from "./v-supply-select-list.vue?vue&type=style&index=0&id=2d32b348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d32b348",
  null
  
)

export default component.exports